import { ProgressUpdateCard } from '../../../../../../blocks/ProgressUpdateCard';
import {
  TimelineItem as TimelineItemType,
  TSessionCheckInTime,
} from '../../../../types/timeline';
import { isSessionEnded } from '../../../../utils/timelineUtils';

import { MeetingsCard } from './MeetingsCard';
import { MissedCheckInCard } from './MissedCheckInCard';
import { OOOCard } from './OOOCard';

interface TimelineItemProps {
  item: TimelineItemType;
  checkInTime?: TSessionCheckInTime;
  isIndividualView?: boolean;
}

export function TimelineItem({
  item,
  checkInTime,
  isIndividualView,
}: TimelineItemProps): JSX.Element | null {
  switch (item.type) {
    case 'ticket':
      return (
        <ProgressUpdateCard
          item={{
            id: item.id,
            checkInId: item.checkInId,
            type: 'ticket',
            title: item.title,
            description: item.description,
            ticketId: item.ticketId,
            progress: {
              current: item.progress?.current || 0,
              previous: item.progress?.previous || 0,
            },
            blockers: item.blockers || '',
            wipLinks: item.wipLinks || '',
            externalLink: item.externalLink,
          }}
          showDescription={isIndividualView}
          hideMenu
        />
      );
    case 'adhoc_task':
      return (
        <ProgressUpdateCard
          item={{
            id: item.id,
            checkInId: item.checkInId,
            type: 'adhoc_task',
            title: item.title,
            description: item.description,
          }}
          hideMenu
          showDescription={isIndividualView}
        />
      );
    case 'MEETINGS':
      return <MeetingsCard checkInTime={checkInTime} item={item} />;
    case 'MISSED_CHECKIN':
      if (checkInTime && isSessionEnded(checkInTime, true)) {
        return <MissedCheckInCard />;
      }
      return null;
    case 'OOO':
      return <OOOCard />;
    default:
      return null;
  }
}
